// 拼接url
export function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' +
        relativeURL.replace(/^\/+/, '') : baseURL
}

/**
 * @description 提取所有参数
 * @param url { string } 链接地址
 * @param withEmpty { boolean } 结果是否包含空值
 * @return Object
 * */
export function translateUrlParams(url, withEmpty = false) {
    const URL = url || window.location.search
    const query = {}
    if (URL.split('?')[1]) {
        const queryArray = URL.split('?')[1].split('&')
        queryArray.forEach(item => {
            const [key, value] = item.split('=')
            if (withEmpty) {
                query[key] = value
            } else {
                if (value !== undefined) {
                    query[key] = value
                }
            }
        })
    }
    return query
}

/**
 * @description 获取页面地址参数
 * @param name { string } 参数名
 * @return string
 * */
export function getParams(name) {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    let param = window.location.search.substr(1).match(reg)
    if (param !== null) {
        return decodeURIComponent(param[2])
    }
    return ''
}

/**
 * @description 从链接中获取参数
 * @param name { string } 参数名
 * @param url { string } 链接
 * @return string
 * */
 export function getParamsByUrl(name, url) {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    let param = url.match(reg)
    if (param !== null) {
        return decodeURIComponent(param[2])
    }
    return ''
}

/**
 * @description 重置服务器host
 * @param baseURL { string } 需要被重置的链接
 * */
export function resetHost(baseURL) {
    let host = baseURL.split('.')
    host[0] = host[0].replace(/gray|test/g, '')
    if (/test|localhost/g.test(location.host)) {
        // host[0] += 'test'
    } else if (/gray/g.test(location.host)) {
        host[0] += 'gray'
    }
    return host.join('.')
}

/**
 * Object对象类型 转 query链接参数
 * @param {*} data
 * @returns
 */
export function serialize(data) {
    if (!data) return '';
    const pairs = [];
    for (const name in data) {
        try {
            if (!Object.prototype.hasOwnProperty.call(data, name)) continue
            if (typeof data[name] === 'function') continue;
            if (data[name]) {
                const value = data[name]?.toString?.() ?? '';
                const nameStr = encodeURIComponent(name);
                const valueStr = encodeURIComponent(value);
                pairs.push(nameStr + '=' + valueStr);
            }
        } catch (err) {
            console.error(err)
        }
    }
    return pairs.join('&');
}